<template>
    <div>
                <div style="width:350px;margin:0 auto;height:80px">
                    <img :src="require('../assets/visa.svg')" class="image" alt="">
                    <img :src="require('../assets/mastercard.svg')" style="padding:20px" class="image" alt="">
                    <img :src="require('../assets/rupay.jpg')" class="image" alt="">
                </div>
            <v-text-field
                type="text"
                v-model="number"
                style="width:350px;margin:0 auto;height:60px"
                label="Enter Debit Card Number" 
                solo />
                <div style="width:350px;margin:0 auto;height:53px">
             <v-text-field
                type="number"
                style="width:70px;float:left"
                label="MM"
                v-model="date"
                solo />
             <v-text-field
                type="number"
                style="width:100px;float:left"
                label="YYYY"
                v-model="year"
                solo />
             <v-text-field
                type="number"
                style="width:100px;float:right"
                label="CCV"
                v-model="ccv"
                solo />
         <div style="width:100%;float:left">
            <v-btn color="primary" style="width:350px;margin:0 auto;" @click="submit">Pay Now</v-btn>
        </div>
                </div>


    </div>
</template>
<script>
export default {
    data(){
        return{
            date:'',
            year:'',
            ccv:'',
            number:'',

        }
    },
    methods:{
         notification(type,message){
            this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000, 
                type:type               
            })
        },
        submit(){
            this.notification("","Currently Not Available!")
        }
    }
}
</script>
<style scoped>
.image{
    width: 110px;
    padding:5px;
    height: 100px;;
    object-fit: contain;
}
</style>



